<template>
  <v-dialog v-model="dialog" persistent fullscreen class="pb-6">
    <v-card>
      <v-card-title
        :class="$vuetify.breakpoint.smAndDown ? 'caption pa-1' : 'subtitle-1'"
      >
        <v-col cols="10" sm="8" md="8" class="mt-2">
          ID: {{ $route.query.id }} <br />
          {{ $route.query.event }}
          <v-chip
            :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : 'ml-2 mt-1'"
            :color="$route.query.active.color"
            outlined
            small
            >{{ $route.query.active.text }}</v-chip
          >
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="2" sm="4" md="4" class="pa-0 pt-0 mb-12">
          <v-btn icon @click="closeDialog()" class="float-right"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-col>
      </v-card-title>
      <v-card-subtitle
        :class="$vuetify.breakpoint.smAndDown ? 'pt-2 pb-0' : 'pt-2 pb-0 ml-3'"
        >{{ $route.query.date }} {{ $gmt() }}</v-card-subtitle
      >
      <v-card-subtitle
        :class="$vuetify.breakpoint.smAndDown ? 'pt-1 pb-0' : 'pt-2 pb-0 ml-3'"
        >{{ $route.query.tournament }}</v-card-subtitle
      >

      <v-card-text class="mt-4">
        <v-list v-show="items || loading">
          <v-expansion-panels>
            <v-expansion-panel v-for="(item, index) in markets" :key="index">
              <!-- Nome do Mercado (Resultado Final, Dupla Chance...) -->
              <v-expansion-panel-header>
                {{ item[0] }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ma-0 pa-0">
                <div
                  v-for="(element, i) in item"
                  :key="i"
                  class="py-4 flex-grow"
                  v-show="i > 0"
                >
                  <template v-if="i > 0">
                    <div class="ml-1 caption">
                      <!-- Nome do Outcome -->
                      Outcome:
                      <v-chip x-small class="mr-2" color="blue">
                        {{ element.nameOutcome }}</v-chip
                      >
                      <br v-if="$vuetify.breakpoint.xsOnly" />
                      <!-- Data de Abertura do Mercado
											{{ $t("opening") }}:
											<v-chip x-small class="ml-2" v-if="element.marketOpen">
												{{ new Date(element.marketOpen).toLocaleString() }}
											</v-chip>
											<v-icon v-else x-small> mdi-close-circle-outline </v-icon>
											<br v-if="$vuetify.breakpoint.xsOnly" /> -->
                      <!-- Data de Fechamento do Mercado -->
                      <!-- {{ $t("closing") }}:
											<v-chip x-small class="ml-2" v-if="element.marketClose">
												{{ new Date(element.marketClose).toLocaleString() }}
											</v-chip>
											<v-icon v-else x-small> mdi-close-circle-outline </v-icon>
											<br v-if="$vuetify.breakpoint.xsOnly" /> -->
                      <!-- Data do Resultado do Mercado -->
                      <!-- {{ $t("result") }}:
											<v-chip x-small class="ml-2" v-if="element.marketResult">
												{{ new Date(element.marketResult).toLocaleString() }}
											</v-chip>
											<v-icon v-else x-small> mdi-close-circle-outline </v-icon>
											<br v-if="$vuetify.breakpoint.xsOnly" /> -->
                    </div>
                    <div
                      :class="
                        $vuetify.breakpoint.xsOnly ? 'ml-1 mt-1' : 'ml-1 mt-2'
                      "
                      class="caption"
                    >
                      <!-- Apostas Realizadas no mercado -->
                      {{ $t("bets") }}:
                      <v-chip x-small class="mx-1" color="green  darken-3">
                        {{ $t("labelCurrency") + element.valorApostado }}
                      </v-chip>
                      <br v-if="$vuetify.breakpoint.xsOnly" />
                      <!-- Prêmios no mercado -->
                      {{ $t("awards") }}:
                      <v-chip x-small class="mx-1" color="purple  darken-3">
                        {{ $t("labelCurrency") + element.valorPremio }}
                      </v-chip>
                      <br v-if="$vuetify.breakpoint.xsOnly" />
                      <!-- Apostas Canceladas -->
                      {{ $t("cancelleds") }}:
                      <v-chip x-small class="mx-1" color="red  darken-3">
                        {{ $t("labelCurrency") + element.valorCanceladas }}
                      </v-chip>
                      <br v-if="$vuetify.breakpoint.xsOnly" />
                      <!-- Comissões -->
                      {{ $t("commissions") }}:
                      <v-chip x-small class="mx-1" color="orange  darken-3">
                        {{ $t("labelCurrency") + element.valorComissoes }}
                      </v-chip>
                    </div>
                  </template>
                </div>
                <v-divider></v-divider>

                <v-row
                  :class="$vuetify.breakpoint.xsOnly ? '' : 'pl-2'"
                  class="mt-2"
                >
                  <!-- Soma dos valores anteriores (apostas, cancelados, ) -->
                  <div v-for="(element, i) in sumMarkets[index]" :key="i">
                    <div
                      v-if="
                        i == 'totalBets' ||
                          i == 'totalPrize' ||
                          i == 'totalCanceled' ||
                          i == 'totalCommissions'
                      "
                      class="my-1 mx-2"
                      :class="
                        $vuetify.breakpoint.xsOnly ? 'ml-3 px-0' : 'my-1 mx-2'
                      "
                      style="font-size: 14px"
                    >
                      {{ $t(i) }} :
                      <v-chip small :color="getColor(i)"
                        >{{ $t("labelCurrency") }}{{ fixedValue(element) }}
                      </v-chip>
                    </div>
                  </div>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-list>

        <div
          class="mt-4 text-center"
          :class="$vuetify.breakpoint.smAndDown ? '' : 'subtitle-1'"
          v-show="!items"
        >
          {{ $t("noBetsFountForThisEvent") }}
        </div>

        <v-divider class="mt-2"></v-divider>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "CollaboratorMarketReportByEvent",
  data: () => ({
    search: "",
    items: [],
    // Soma dos mercados
    sumMarkets: {},
    // Mercados com apostas
    markets: {},
    loading: false,
  }),
  computed: {
    dialog() {
      return this.$store.state.showDialogAllMarketsReport;
    },
    outcomes() {
      return this.$store.state.outcomes;
    },
    marketsList() {
      return this.$store.state.markets;
    },
  },

  mounted() {
    // Get dos dados de apostas no evento
    this.marketReportByEvent();
  },

  methods: {
    reset() {
      this.items = [];
      this.markets = {};
      this.sumMarkets = {};
    },
    closeDialog() {
      this.$router.go(-1);
      this.$store.commit("showDialogAllMarketsReport", false);
    },
    async marketReportByEvent() {
      this.reset();
      this.loading = true;
      try {
        const body = {
          id_event: this.$route.params.id,
        };
        const response = await this.$request.post(
          "colab/events/marketReportByEvent",
          body
        );
        if (!response) return;
        // Contruindo a composição da view
        this.buildReportAllMarkets(response.dados);
      } catch {
        (error) => {
          error;
        };
      } finally {
        this.loading = false;
      }
    },
    // Contruindo os objetos dinâmicos para criar a view
    async buildReportAllMarkets(data) {
      this.reset();
      this.items = data;
      if (!this.items) return;
      let marketsObj = new Object();
      let sumObj = new Object();
      const reducer = (previousValue, currentValue) =>
        Number(previousValue) + Number(currentValue);
      // Contruindo o marketObj com o ID do Mercado como chave
      this.items.map((item) => {
        marketsObj[item.id_market] = [];
        // Contruindo o SomaObj com o ID do Mercado como chave
        sumObj[item.id_market] = {
          valor_apostado: [],
          valor_premio: [],
          valor_canceladas: [],
          valor_comissoes: [],
        };
        // Inserindo o nome do mercado como Item "0" de todos os arrays

        this.marketsList.map((market) => {
          if (item.id_market == market.id_market) {
            // Sempre o Nome dos mercados serão o primeiro item do marketsObj
            marketsObj[item.id_market].push(market.name_market);
          }
        });
      });
      // Enviando para MarketObj.outcomes as inforamações para marketObj
      // Após isto cada item de marketsObj vai receber as informações como id_outcome, name_outcome para renderizar na view
      this.items.map((item) => {
        this.outcomes.map((outcome) => {
          if (outcome.id_outcome == item.id_outcome) {
            // O segundo item o market Obj é um grande objeto com os valores necessários para montar a view
            marketsObj[item.id_market].push({
              idMarket: outcome.name_outcome,
              nameOutcome: outcome.name_outcome,
              idOutcome: outcome.id_outcome,
              // marketOpen: item.market_open,
              // marketClose: item.market_close,
              // marketResult: item.market_result,
              valorApostado: item.valor_apostado ? item.valor_apostado : 0,
              valorPremio: item.valor_premio ? item.valor_premio : 0,
              valorCanceladas: item.valor_canceladas
                ? item.valor_canceladas
                : 0,
              valorComissoes: item.valor_comissoes ? item.valor_comissoes : 0,
            });

            // Realizando o envio dos valores que serão necessários soma

            sumObj[item.id_market].valor_apostado.push(item.valor_apostado);
            sumObj[item.id_market].valor_premio.push(item.valor_premio);
            sumObj[item.id_market].valor_canceladas.push(item.valor_canceladas);
            sumObj[item.id_market].valor_comissoes.push(item.valor_comissoes);
          }
        });
      });
      // Realizando a soma dos valores
      this.items.map((item) => {
        sumObj[item.id_market].totalBets = sumObj[
          item.id_market
        ].valor_apostado.reduce(reducer);

        sumObj[item.id_market].totalPrize = sumObj[
          item.id_market
        ].valor_premio.reduce(reducer);

        sumObj[item.id_market].totalCanceled = sumObj[
          item.id_market
        ].valor_canceladas.reduce(reducer);

        sumObj[item.id_market].totalCommissions = sumObj[
          item.id_market
        ].valor_comissoes.reduce(reducer);
      });

      // console.log("markets", marketsObj);
      // console.log("soma", sumObj);
      this.markets = marketsObj;
      this.sumMarkets = sumObj;
    },
    getColor(val) {
      const obj = {
        totalBets: "green  darken-3",
        totalPrize: "purple  darken-3",
        totalCanceled: "red  darken-3",
        totalCommissions: "orange  darken-3",
      };
      return obj[val];
    },
    // Coloca os valores com apenas dois items após inteiro
    fixedValue(element) {
      return Number(element).toFixed(2);
    },
  },
};
</script>
